module.exports = __webpack_public_path__ + "img/pen-white-icon.b350f8dc.svg";